
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.4 11.5V5.1c0-.6-.4-1-1-1H10.6c-.6 0-1 .4-1 1s.4 1 1 1h16.8v4.5H17c-7 0-13.2 5-14.7 12l-.4 2.2c-.1.3 0 .6.2.8.2.2.5.4.8.4h28.2c.3 0 .6-.1.8-.4.2-.2.3-.5.2-.8l-2.7-13.3zM4.1 24l.2-1C5.6 17 11 12.6 17 12.6h10.6L29.9 24H4.1z","fill":"#47AEA6"}}),_c('path',{attrs:{"d":"M2.7 28.9h28.8","stroke":"#F9A91E","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14 21.2a2.2 2.2 0 100-4.4 2.2 2.2 0 000 4.4zm6.9 0a2.2 2.2 0 100-4.4 2.2 2.2 0 000 4.4z","fill":"#F9A91E"}})])
          )
        }
      }
    